import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import { getProxyUrl } from '../../utils/image';

function SpectatorsRow({ stats, position }) {
  const { teamName, name, average, totalHome, homeMatch, logoImageUrl } = stats;

  const getClassName = () => {
    return position === 1
      ? 'stats-table__row bg-comp-pink'
      : 'stats-table__row';
  };

  return (
    <div className={getClassName()}>
      <div className="stats-table__position stats-table__position--status">
        <svg
          className="arrow arrow--up invisible"
          width="11"
          height="13"
          viewBox="0 0 11 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.0156919 5.60568L5.50785 0.461426L11 5.60568L9.71327 6.81693L6.41797 3.73892L6.41797 12.4614H4.58202L4.58203 3.72468L1.28673 6.80268L0 5.59142L0.0156919 5.60568Z"
            fill="currentColor"
          />
        </svg>
        {position}
      </div>
      <div className="stats-table__name flex-grow-1">
        <div className="name-with-team-logo">
          <img
            className="ms-2"
            src={getProxyUrl(logoImageUrl, 50, 50)}
            alt=""
          />
          {teamName || name}
        </div>
      </div>
      <div className="stats-table__played">{homeMatch}</div>
      <div className="stats-table__played heading-stats-name justify-content-end d-flex">
        {totalHome}
      </div>
      <div className="stats-table__played justify-content-end d-flex">
        {average}
      </div>
    </div>
  );
}

SpectatorsRow.propTypes = {
  position: PropTypes.number.isRequired,
  stats: PropTypes.shape({
    teamName: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    average: PropTypes.number.isRequired,
    totalHome: PropTypes.number.isRequired,
    homeMatch: PropTypes.number.isRequired,
    logoImageUrl: PropTypes.string.isRequired,
  }).isRequired,
};

export default SpectatorsRow;
